import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('CardMeta'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-card-advance'
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  render: function render() {
    var h = arguments[0];
    var _this$$slots = this.$slots,
        slotAvatar = _this$$slots.avatar,
        slotTitle = _this$$slots.title,
        slotDesc = _this$$slots.desc,
        prefixCls = this.prefixCls,
        title = this.title,
        desc = this.desc;
    var titleContent = slotTitle || title;
    var descContent = slotDesc || desc;
    var detailNode = null;

    if (titleContent || descContent) {
      detailNode = h("div", {
        "class": "".concat(prefixCls, "-meta-detail")
      }, [titleContent ? h("div", {
        "class": "".concat(prefixCls, "-meta-title")
      }, [titleContent]) : null, descContent ? h("div", {
        "class": "".concat(prefixCls, "-meta-description")
      }, [descContent]) : null]);
    }

    return h("div", {
      "class": "".concat(prefixCls, "-meta")
    }, [slotAvatar ? h("div", {
      "class": "".concat(prefixCls, "-meta-avatar")
    }, [slotAvatar]) : null, detailNode]);
  }
};